import { formData, payment } from '../constants/actions'

const initialState = {
  paymentData: {},
  paymentType: '',
  braintreeToken: null,
  paymentMethod: { id: null, currency: null, type: null },
  orderStatus: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case payment.RESET_FORM:
      return { ...initialState }
    case payment.SET_PAYMENT_DATA:
      return {
        ...state,
        paymentData: action.payload || null,
      }
    case payment.SET_BRAINTREE_PAYMENT_TOKEN:
      return { ...state, braintreeToken: action.payload }
    case payment.SUBMIT_PAYMENT:
      return {
        ...state,
        paymentType: action.payload.paymentType,
      }
    case formData.RESET_FORM: {
      return { ...initialState }
    }
    case payment.SET_PAYMENT_METHOD:
      return { ...state, paymentMethod: action.payload }
    case payment.SET_ORDER_STATUS:
      return { ...state, orderStatus: action.payload }
    default:
      return state
  }
}
